import React from 'react';
import './App.css';
import { FaUniversity, FaBook, FaMicrophoneAlt, FaBriefcase, FaEnvelope, FaGithub, FaTwitter } from 'react-icons/fa';
import { SiGooglescholar } from "react-icons/si";
import { FiExternalLink } from 'react-icons/fi';
import { Award } from 'lucide-react';

function App() {
  return (
    <div className="App"> 
      <div className="container">
        {/* --- 左カラム --- */}
        <div className="left-column">
          <div className="profile-image-container">
            <img src="/no-glasses-square.jpg" alt="Profile" className="profile-image" />
          </div>
          <h1 className="profile-name">Kotaro Ikeda<br/>(池田滉太郎)</h1>
          <p className="profile-title"> Ph.D. Student, Massachusetts Institute of Technology</p>
          <a href={process.env.PUBLIC_URL + '/CV.pdf'} target="_blank" rel="noopener noreferrer" className="cv-download-button-left">
            Download CV (PDF)
          </a>
          <div className="contact-section section">
            <h3><FaEnvelope /> Contact</h3> 
            <div className="contact-info">
              <p>E-mail: <a href="mailto:kotaroik@mit.edu">kotaroik@mit.edu</a></p>
            </div>
          </div>
          <div className="links-section section">
            <h3>Links</h3>
            <ul className="links-list">
              <li><a href="https://github.com/kotatumuri-room" target="_blank" rel="noopener noreferrer"><FaGithub /> GitHub</a></li>
              <li><a href="https://twitter.com/kotaro_IK" target="_blank" rel="noopener noreferrer"><FaTwitter /> X (Twitter)</a></li>
              <li><a href="https://scholar.google.com/citations?user=BLznLMkAAAAJ&hl" target="_blank" rel="noopener noreferrer"><SiGooglescholar /> Google Scholar</a></li>
            </ul>
          </div>
        </div>

        {/* --- 右カラム --- */}
        <div className="right-column">
          <section id="about" className="section">
            <h2>About Me</h2>
            Hi, I'm Kotaro Ikeda, a Ph.D. student at MIT EECS advised by <a href="https://people.csail.mit.edu/jsolomon/" target="_blank" rel="noopener noreferrer">Prof. Justin Solomon</a>. My current research focuses on developing and understanding machine learning in a geometric perspective. 
          </section>
          <section id="education" className="section">
            <h2><FaUniversity /> Education</h2> 
            <ul className="text-list">
              <li><strong>Apr. 2022 - Mar. 2026</strong> The University of Tokyo, Department of Mathematical Engineering and Information Physics, School of Engineering (BE)</li>
              <li><strong>Apr. 2026 - Aug. 2026</strong> The University of Tokyo, Department of Mathematical Informatics, Graduate School of Information Science and Technology (ME)</li>
              <li><strong>Sep. 2026 - present</strong> Massachusetts Institute of Technology, Electrical Engineering and Computer Science (Ph.D.)</li>
            </ul>
          </section>
          <section id="honors-and-awards" className="section">
            <h2><Award /> Honors & Awards</h2> 
            <ul className="text-list">
              <li className="publication-item">
                <a href="https://www.ipsj.or.jp/award/gi-award2.html" target="_blank" rel="noopener noreferrer">IPSJ 58th GI Award  <FiExternalLink /></a>
                <span className="authors">Information Processing Society of Japan, Game Informatics research society (2026)</span>
              </li>
              <li className="publication-item">
                <a href="https://funaifoundation.jp/scholarship/en/scholarship_guidelines_phd.html" target="_blank" rel="noopener noreferrer">Funai Overseas Scholarship (2026-2028)<FiExternalLink /></a>
                <span className="authors">Covers tuition fees up to $14,000 per year, living expenses $36,000 per year, and medical insurance.</span>
              </li>
              <li className="publication-item">
                <strong>Dean's Award for Outstanding Research (工学部長賞(研究優秀))</strong>
                <span className="authors">School of Engineering, The University of Tokyo (Mar 2026)</span>
              </li>
            </ul>
          </section>
          <section id="publications" className="section">
            <h2><FaBook /> Publications</h2> 
            <ul>
              <li className="publication-item">
                <a href="https://arxiv.org/abs/2504.03188" target="_blank" rel="noopener noreferrer">Pairwise Optimal Transports for Training All-to-All Flow-Based Condition Transfer Model<FiExternalLink /></a>
                <span className="authors">Kotaro Ikeda, Masanori Koyama, Jinzhe Zhang, Kohei Hayashi, Kenji Fukumizu</span>
                <span className="conference">NeurIPS 2025 Poster</span>
                <div className="extra-links">
                  <a href="https://github.com/kotatumuri-room/A2A-FM" target="_blank" rel="noopener noreferrer" className="press-release-link">Code <FiExternalLink /></a>
                  <a href="https://openreview.net/forum?id=Wlx38NK0Om" target="_blank" rel="noopener noreferrer" className="press-release-link">Open Review<FiExternalLink /></a>
                  <a href="https://neurips.cc/virtual/2025/poster/117564" target="_blank" rel="noopener noreferrer" className="press-release-link">NeurIPS Page<FiExternalLink /></a>
                </div>
              </li>
              <li className="publication-item">
                <a href="https://doi.org/10.1103/x5vj-8jq9" target="_blank" rel="noopener noreferrer">Speed-accuracy relations for diffusion models: Wisdom from nonequilibrium thermodynamics and optimal transport<FiExternalLink /></a>
                <span className="authors">Kotaro Ikeda, Tomoya Uda, Daisuke Okanohara, Sosuke Ito</span>
                <span className="conference">Physical Review X 15, 031031 (2025)</span>
                <div className="extra-links">
                  <a href="https://www.s.u-tokyo.ac.jp/ja/press/10887/" target="_blank" rel="noopener noreferrer" className="press-release-link">Press Release (JA)<FiExternalLink /></a>
                  <a href="https://www.eurekalert.org/news-releases/1093188/" target="_blank" rel="noopener noreferrer" className="press-release-link">Press Release (EN)<FiExternalLink /></a>
                </div>
              </li>
            </ul>
          </section>
          <section id="conferences-in-japan" className="section">
            <h2><FaMicrophoneAlt /> Conferences in Japan</h2> 
            <ul>
              <li className="publication-item">
                <a href="https://www.ipsj.or.jp/kenkyukai/event/gi58.html" target="_blank" rel="noopener noreferrer"> Two Techniques for Multi-player Games: Lightweight Value Training and Collusion-Aware Monte Carlo Tree Search for Blokus<FiExternalLink /></a>
                <span className="authors">Hinata Tokuda, Kotaro Ikeda</span>
                <span className="conference">IPSJ SIG-GI 58th Research Meeting</span>
              </li>
              <li className="publication-item">
                <a href="https://ibisml.org/ibis2024/posters/" target="_blank" rel="noopener noreferrer">Speed-accuracy relations for diffusion models: Wisdom from nonequilibrium thermodynamics and optimal transport<FiExternalLink /></a>
                <span className="authors">Kotaro Ikeda, Tomoya Uda, Daisuke Okanohara, Sosuke Ito</span>
                <span className="conference">The 27th Information-Based Induction Sciences Workshop (IBIS 2024)</span>
              </li>
              <li className="publication-item">
                <a href="https://ibisml.org/ibis2024/posters/" target="_blank" rel="noopener noreferrer">GeoBeta Flow Matching<FiExternalLink /></a>
                <span className="authors">Kotaro Ikeda, Masanori Koyama, Kohei Hayashi, Kenji Fukumizu</span>
                <span className="conference">The 27th Information-Based Induction Sciences Workshop (IBIS 2024)</span>
              </li>
            </ul>
          </section>
          <section id="employment" className="section">
            <h2><FaBriefcase /> Employment</h2> 
            <ul className="text-list">
              <li><strong> Part-time engineer</strong>, Akari Inc., (May 2023 - Mar 2024)</li>
            </ul>
            <ul className="text-list">
              <li><strong>Summer Internship</strong>, Preferred Networks Inc., (Aug 2024 - Mar 2025)</li>
            </ul>
            <ul className="text-list">
              <li><strong>Part-time engineer</strong>, Meltly Inc., (Apr 2025 - Aug 2026)</li>
            </ul>
          </section>
        </div>
      </div>
      
      <footer>
        <p>&copy; {new Date().getFullYear()} Kotaro Ikeda. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default App;